export const ANGULAR_ROUTING_OP = 'ui.angular.routing';

export const ANGULAR_INIT_OP = 'ui.angular.init';

export const ANGULAR_OP = 'ui.angular';
